var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zwx-verify-code",style:(_vm.divStyle)},[_c('img',{staticClass:"verify-img",style:(_vm.imgStyle),attrs:{"src":_vm.imgCodePath,"alt":""},on:{"click":function($event){return _vm.imgCodeReload()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }